export default "__VITE_ASSET__gDQWx4sl__"